import { render, staticRenderFns } from "./tabCustomerCollectibles.vue?vue&type=template&id=0ccd9538&"
import script from "./tabCustomerCollectibles.vue?vue&type=script&lang=js&"
export * from "./tabCustomerCollectibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports